<div class="logged-in-view h-full overflow-y-auto">
    <div class="w-full">
        <h1 class="text-app-primary-10 mb-18">Patienten</h1>
        <div class="flex flex-col gap-4">
            @for (patient of patients; track patient.id) {
                <div
                    class="patient-item flex flex-col lg:flex-row justify-between items-center bg-white p-6 rounded-button shadow-xs border border-app-primary-10 transition-all hover:shadow-md gap-2">
                    <div class="flex items-center gap-4">
                        <div class="flex flex-col">
                            <div class="text-lg font-bold text-app-primary-10">{{ patient.firstName }} {{ patient.lastName }}</div>
                            <span class="text-sm text-app-primary-10/60 hidden lg:block">{{ patient.email }}</span>
                        </div>
                    </div>
                    <button class="btn tertiary-button" (click)="routeToPatientFile(patient)">
                        <span>Zur Patientenakte</span>
                    </button>
                </div>
            } @empty {
                <div class="text-center py-12">
                    <p class="text-app-primary-10/50 italic">Noch keine Patienten vorhanden.</p>
                </div>
            }
        </div>
    </div>
</div>
